import { useLocation } from "react-router";
function Header() {
  const location = useLocation();

  const pageTitles = {
    "/agenda": "Agenda",
    "/speakers": "Speakers",
    "/gallery": "Gallery",
    "/registration": "Registration",
    "/contact": "Contact Us",
    "/signin": "Sign In",
    "/feedback": "Feedback",
    "/": "Upcoming Events & Conferences",
  };

  const pageKey = Object.keys(pageTitles).find((path) =>
    location.pathname.endsWith(path),
  );

  const title = pageKey ? pageTitles[pageKey] : "Overview";

  return (
    <div>
      <section className="bg-gradient-to-b from-[#0166b1] to-[#b9d5eb] lg:grid lg:place-content-center mb-3 ">
        <div className="mx-auto w-screen max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8 lg:py-32">
          <div className="mx-auto max-w-prose text-center">
            <h1 className="drop-shadow-sm uppercase tracking-widest font-extrabold sm:text-5xl text-white ">
              {title.toUpperCase()}
            </h1>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Header;
